import {useEffect, useState} from "react";
import {BASE_NAME} from "../../../services/utils/ApiUrls";
import {getConfig} from "../../../services/utils/ConfigUtils";

const API_URL = BASE_NAME + "google-auth/check";

const useFetchGoogleStatus = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [firstLoad, setFirstLoad] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await fetch(`${API_URL}`, getConfig());
                if (!response.ok) {
                    console.error(response);
                    throw new Error("Errore nel recupero delle informazioni!");
                }
                const res = await response.json();
                setData(res);
            } catch (err) {
                console.error(err);
                setError(err.message);
            } finally {
                setLoading(false);
                setFirstLoad(false);
            }
        };

        fetchData().then();
    }, []);

    return {data, loading, error, firstLoad};
};

export default useFetchGoogleStatus;
